import { Badge } from '@onward-delivery/design/badge';

// Badge is a display-only <span>, so the interaction and a11y live here. Colours are overridden
// because both variants are solid fills and the design wants a tint -- safe because Badge composes
// through cn() (tailwind-merge), so conflicting utilities resolve rather than race on CSS order.
const ToggleBadge = ({ label, selected, onToggle }) => (
    <Badge
        className={[
            'cursor-pointer select-none rounded-full border px-3 py-1 text-sm transition-colors',
            selected
                ? 'border-primary bg-primary/10 text-primary'
                : 'border-border bg-transparent text-foreground hover:bg-muted/40',
        ].join(' ')}
        role="button"
        tabIndex={0}
        aria-pressed={selected}
        onClick={onToggle}
        onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onToggle();
            }
        }}
    >
        {label}
    </Badge>
);

export default ToggleBadge;
